import {getRtlLanguages} from "../appConfig/appConfigForward";

export class I18n {
    private rtlLanguages = getRtlLanguages();
    private _direction= 'ltr';
    constructor(private tmhDynamicLocale,  private $translate){

    }

    public getLanguage() {
        return this.$translate.use();
    }

    public setLanguage(lang) {
        this.$translate.preferredLanguage(lang);

        let lang_arr = lang.split('_');
        if(lang_arr.length > 1){
            //bug in java country code specification in hebrew. It should be he instead of il
            if(lang_arr[0] === 'iw') {
                lang_arr[0] = 'he';
            }
            lang_arr[1]= lang_arr[1].toLowerCase();
        }
        this.tmhDynamicLocale.set(lang_arr.join('-'));
        return this.$translate.use(lang).then(()=>{
            this.setPageLanguage();
        });
    }

    public get direction(){
        return this._direction;
    }


    public setPageLanguage(lang ?){
        let selectedLanguage = this.$translate.use() || lang;
        let htmlRoot = <HTMLLinkElement>document.getElementById('primoExploreRoot');
        // since java Locale has a legacy problme wit hthe following code we will replace them manually
        let javaLocaleFixer = {iw: 'he',ji: 'yi', in: 'id'};
        if(htmlRoot && selectedLanguage && selectedLanguage.length >= 2) {
            let code = selectedLanguage.substring(0, 2);
            if(javaLocaleFixer[code]){
                code = javaLocaleFixer[code];
            }
            htmlRoot.setAttribute('lang', code);
            let direction;
            if(this.rtlLanguages.has(code)) {
                direction = 'rtl';
            }
            else {
                direction = 'ltr';
            }
            this._direction= direction;
            htmlRoot.setAttribute('dir', direction);

        }
    }


}

I18n.$inject = ['tmhDynamicLocale', '$translate'];


// WEBPACK FOOTER //
// ./src/main/webapp/components/i18n/I18n.service.ts